import { Alert, Button } from 'antd'
import { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import API_FUNCTIONS from '@/api'
import Loading from '@/components/Loading'
import { useUpdateURLSearchParams } from '@/hooks/useQuery'
import { useLoadCustomer } from '@/queries/customers/useLoadCustomer'
import Modal from '@/ui/Modal'
import { buildFullName } from '@/utils/helpers'

export const ConfirmDeleteClientModal = () => {
  const { clientId } = useParams<{ clientId: string }>()
  const history = useHistory()
  const updateParams = useUpdateURLSearchParams()
  const {
    data: clientDetail,
    isLoading: isLoadingClient,
    isError,
  } = useLoadCustomer(clientId)

  const fullName = buildFullName(
    clientDetail?.first_name,
    clientDetail?.last_name
  )
  const [isLoadingDelete, setIsLoadingDelete] = useState(false)

  const onConfirm = async () => {
    setIsLoadingDelete(true)
    try {
      await API_FUNCTIONS.deleteClient(clientDetail?.id)
      updateParams(['deletePatient', undefined])
      history.replace('/clients')
      toast.info(`${fullName} deleted`)
    } catch (error) {
      toast.error('Error deleting patient')
    }
  }

  return (
    <Modal
      open
      footer={() => undefined}
      onCancel={() => updateParams(['deletePatient', undefined])}
      title="Delete Patient"
      width={{
        xs: '90%',
        sm: '80%',
        md: '70%',
        lg: '50%',
        xl: '40%',
        xxl: '30%',
      }}
    >
      {isLoadingDelete && <Loading className="!h-48" />}

      {!isLoadingDelete && !isLoadingClient && isError && (
        <p>This user doesn't exist.</p>
      )}

      {!isLoadingDelete && !isLoadingClient && !isError && (
        <>
          <Alert
            showIcon
            className="my-4"
            description={
              <div className="flex flex-col">
                <span>This patient will be removed permanently.</span>
                <span className="font-bold">
                  <small>●</small> {fullName}
                </span>
              </div>
            }
            message="Are you sure you want to permanently delete this patient?"
            type="warning"
          />
          <div className="mt-8 flex w-full justify-end gap-2">
            <Button
              disabled={isLoadingDelete}
              onClick={() => updateParams(['deletePatient', undefined])}
            >
              Cancel
            </Button>
            <Button
              danger
              disabled={isLoadingDelete}
              onClick={onConfirm}
              type="primary"
            >
              Delete
            </Button>
          </div>
        </>
      )}
    </Modal>
  )
}
